module.exports = __webpack_public_path__ + "img/xinxiaz.48621ec6.svg";